/**
 * 输入框 @ 引用素材：检测、定位、删除触发文本
 */

export function getTextNodeAtCursor(range) {
  if (!range) return { node: null, offset: 0 }
  let node = range.startContainer
  let offset = range.startOffset
  if (node.nodeType === 3) return { node, offset }
  if (node.nodeType === 1) {
    const children = node.childNodes
    if (!children || !children.length) return { node: null, offset: 0 }
    if (offset > 0) {
      const prev = children[offset - 1]
      if (prev && prev.nodeType === 3) {
        return { node: prev, offset: (prev.textContent || '').length }
      }
      if (prev && prev.nodeType === 1) {
        const last = prev.lastChild
        if (last && last.nodeType === 3) {
          return { node: last, offset: (last.textContent || '').length }
        }
      }
    }
    const cur = children[offset]
    if (cur && cur.nodeType === 3) return { node: cur, offset: 0 }
  }
  return { node: null, offset: 0 }
}

/**
 * @param {HTMLElement} composerEl
 * @returns {{ query: string, delRange: Range } | null}
 */
export function detectAtMention(composerEl) {
  const sel = window.getSelection ? window.getSelection() : null
  if (!sel || !sel.rangeCount || !composerEl) return null
  const range = sel.getRangeAt(0)
  if (!range.collapsed) return null
  if (!composerEl.contains(range.commonAncestorContainer)) return null

  const { node, offset } = getTextNodeAtCursor(range)
  if (!node || node.nodeType !== 3) return null

  const text = node.textContent || ''
  const before = text.slice(0, offset)
  const atIdx = before.lastIndexOf('@')
  if (atIdx < 0) return null

  if (atIdx > 0) {
    const prev = before.charAt(atIdx - 1)
    if (prev && !/\s/.test(prev)) return null
  }

  const query = before.slice(atIdx + 1)
  if (/\s/.test(query)) return null

  const delRange = document.createRange()
  delRange.setStart(node, atIdx)
  delRange.setEnd(node, offset)

  return { query, delRange }
}

export function getRangeClientRect(range) {
  if (!range) return null
  let rect = range.getBoundingClientRect()
  if (rect && (rect.width > 0 || rect.height > 0)) return rect

  try {
    const marker = document.createElement('span')
    marker.textContent = '\u200b'
    range.insertNode(marker)
    rect = marker.getBoundingClientRect()
    marker.remove()
    return rect
  } catch (e) {
    return null
  }
}

export function buildAtMentionPanelStyle(range) {
  const rect = getRangeClientRect(range)
  if (!rect) {
    return { display: 'none' }
  }
  const margin = 8
  const panelW = 320
  const vw = window.innerWidth || 1200
  const vh = window.innerHeight || 800
  let left = rect.left
  let top = rect.bottom + margin
  if (left + panelW + margin > vw) left = Math.max(margin, vw - panelW - margin)
  if (top + 280 > vh - margin) {
    top = Math.max(margin, rect.top - margin - 260)
  }
  return {
    position: 'fixed',
    top: `${Math.round(top)}px`,
    left: `${Math.round(left)}px`,
    width: `${panelW}px`,
    zIndex: '6000'
  }
}

/**
 * @param {{ localUploads?: Array, assetRows?: Array, query?: string }} opts
 */
export function buildAtMentionItems(opts) {
  const q = String((opts && opts.query) || '')
    .trim()
    .toLowerCase()
  const items = []
  const seen = new Set()

  const push = (raw, source) => {
    if (!raw || !raw.url) return
    const url = String(raw.url)
    if (seen.has(url)) return
    seen.add(url)
    const name = String(raw.name || raw.title || '未命名')
    if (q && !name.toLowerCase().includes(q)) return
    items.push({
      kind: raw.kind === 'video' ? 'video' : 'image',
      url,
      name,
      source
    })
  }

  for (const u of (opts && opts.localUploads) || []) {
    push({ ...u, name: u.name }, 'preview')
  }
  for (const a of (opts && opts.assetRows) || []) {
    push({ kind: a.kind, url: a.url, name: a.title }, 'asset')
  }
  return items
}
